import React, { Suspense } from 'react';

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';
import { ARCHEM_APPS } from '@src/app/pages/home/ArchemApps';
import ProtectedRoute from '@src/app/routes/ProtectedRoute';

const MaintenanceCustomerDialog = LazyLoadable(lazy(() => import('./maintenance/customers/dialog/MaintenanceCustomerDialog')));
const FinishedProductDialog = LazyLoadable(lazy(() => import('./maintenance/finished-product/dialog/FinishedProductDialog')));

const MaintenanceList = LazyLoadable(lazy(() => import('./settings/maintenace-list/MaintenanceList')));
const MaintenanceCustomers = LazyLoadable(lazy(() => import("./maintenance/customers/card/MaintenanceCustomerCard")));
const MaintenanceSuppliers = LazyLoadable(lazy(() => import("./maintenance/suppliers/SuppliersCard")));
const FinishedProducts = LazyLoadable(lazy(() => import("./maintenance/finished-product/card/FinishedProductCard")));
const RawMaterials = LazyLoadable(lazy(() => import("./maintenance/raw-materials/card/RawMaterialsCard")))
const DailyMailReportsCard = LazyLoadable(lazy(() => import("./maintenance/daily-mail-reports/DailyMailReportsCard")))
const ProductGroups = LazyLoadable(lazy(() => import('./maintenance/product-groups/ProductGroupsCard')))

const SupplierDialog = LazyLoadable(lazy(() => import("./maintenance/suppliers/dialog/SupplierDialog")));
const RawMatsDialog = LazyLoadable(lazy(() => import("./maintenance/raw-materials/dialog/RawMaterialsDialog")));

const Dashboard = LazyLoadable(lazy(() => import("./dashboard")))

export const ROUTES_SYSTEM_MAINTENANCE = [
  {
    path: "/maintenance",
    element: <Suspense fallback={<LoadingSpinner />}> <ProtectedRoute module_name={ARCHEM_APPS.SETTINGS.module_name} /> </Suspense>,
    children: [
      {
        index: true,
        element: <Dashboard />
      },
      {
        path: "lists/:list_type",
        element: <MaintenanceList />
      },
      {
        path: 'suppliers/*',
        element: <MaintenanceSuppliers />,
        children: [
          {
            path: 'new',
            element: <SupplierDialog />
          },
          {
            path: ':supplier_id',
            element: <SupplierDialog />
          }
        ]
      },
      {
        path: 'productgroups',
        element: <ProductGroups />
      },
      {
        path: 'customers/*',
        element: <MaintenanceCustomers />,
        children: [
          {
            path: 'new',
            element: <MaintenanceCustomerDialog show />
          },
          {
            path: ':customer_id',
            element: <MaintenanceCustomerDialog show />
          }
        ]
      },
      {
        path: 'finishedproducts/*',
        element: <FinishedProducts />,
        children: [
          {
            path: 'new',
            element: <FinishedProductDialog show />
          },
          {
            path: ':finished_product_id',
            element: <FinishedProductDialog show />
          }
        ]
      },
      {
        path: 'rawmaterials/*',
        element: <RawMaterials />,
        children: [
          {
            path: 'new',
            element: <RawMatsDialog show />
          },
          {
            path: ':raw_material_id',
            element: <RawMatsDialog show />
          }
        ]
      },
      {
        path: 'dailyreports',
        element: <DailyMailReportsCard />
      },
    ],
  },

];
